import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PartnerColumn, PartnerSummaryRow } from '../components/partner/PartnerColumns';
import { StatementsArchive } from '../components/partner/StatementsArchive';

export default function PartnerPage() {
  const { api, user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [statements, setStatements] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only Danny and Mel can access
    const allowed = ['mel@a2gdesigns.com', 'dt@dmerus.com'];
    if (user && !allowed.includes(user.email?.toLowerCase())) {
      toast.error('Access denied — partners only');
      navigate('/crm');
      return;
    }
    loadData();
  }, [user]);

  const loadData = async () => {
    try {
      const [dashRes, stmtRes] = await Promise.all([
        api.get('/api/partner/dashboard'),
        api.get('/api/partner/statements'),
      ]);
      setData(dashRes.data);
      setStatements(stmtRes.data || {});
    } catch (err) {
      if (err.response?.status === 403) {
        toast.error('Access denied — partners only');
        navigate('/crm');
      } else {
        toast.error('Failed to load partner data');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleArchive = async () => {
    if (!window.confirm('Archive this month\'s partner statement? This cannot be undone.')) return;
    try {
      await api.post('/api/partner/statements/archive', {});
      toast.success('Statement archived');
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to archive');
    }
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-4 border-[#014DB7] border-t-transparent rounded-full animate-spin" /></div>;
  if (!data) return null;

  return (
    <div className="space-y-6" data-testid="partner-page">
      <div>
        <h1 className="text-2xl font-bold text-[#0A1628]">Partner Reports</h1>
        <p className="text-gray-500">{data.current_month} — Net profit split equally (1/3 each)</p>
      </div>
      <PartnerSummaryRow income={data.income} expenses={data.expenses} net={data.net_profit} />
      <div className="grid grid-cols-4 gap-4">
        <PartnerColumn name="Danny Techera" role="Partner / CEO" share={data.splits.danny} color="border-blue-300" pct="45%" />
        <PartnerColumn name="Mel Tallagsen" role="Partner / CTO" share={data.splits.mel} color="border-green-300" pct="45%" />
        <PartnerColumn name="DME R'US" role="Company Reserve" share={data.splits.dmerus} color="border-amber-300" pct="10%" />
        <StatementsArchive statements={statements} onArchive={handleArchive} currentMonth={data.current_month} />
      </div>
    </div>
  );
}
